<template>
  <div>
    <div class="header py-7 py-lg-8 pt-lg-4"></div>
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <img style="width:200px; display:block; margin: 0 auto 2rem auto" :src="logo" class="navbar-brand-img" alt="RapidAIM" />
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <base-alert v-if="error" type="danger">
                {{ error }}
              </base-alert>
              <base-alert v-if="showSuccess" type="success">
                Your password was successfully updated.
              </base-alert>
              <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(login)">
                  <base-input
                    alternative
                    class="mb-3"
                    name="username"
                    :rules="{ required: true, min: 2 }"
                    prepend-icon="fas fa-user"
                    placeholder="Username / email"
                    v-model="model.username"
                  >
                  </base-input>
                  <base-input
                    alternative
                    class="mb-3"
                    name="password"
                    :rules="{ required: true, min: 4 }"
                    prepend-icon="fas fa-lock"
                    type="password"
                    placeholder="Password"
                    v-model="model.password"
                  >
                  </base-input>
                  <div class="text-center">
                    <base-button type="primary" native-type="submit" class="my-4">Sign in</base-button>
                  </div>
                </b-form>
              </validation-observer>
              <b-row>
            <b-col class="text-center" cols="12" >
              <router-link to="/SendResetCode" class="text-light"><small>Forgot password?</small></router-link>
            </b-col>
          </b-row>
            </b-card-body>
          </b-card>
          
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import BaseAlert from '@/components/BaseAlert';
import api from '@/api';

const { VUE_APP_USER_GROUP_NAME } = process.env; 

export default {
  components: {
    BaseAlert
  },
  props: {
    logo: {
      type: String,
      default: 'https://i2.wp.com/rapidaim.io/wp-content/uploads/2019/04/logo-horizontal-reversed-01-2x-contrast.png?fit=395%2C102&ssl=1',
      description: 'RapidAIM'
    },
  },
  data() {
    return {
      error: null,
      model: {
        username: '',
        password: ''
      }, 
      authFlow: 'USER_SRP_AUTH',
      showSuccess: this.$route.params && this.$route.params.success
    };
  },
  methods: {
    async login() {
      const { username, password } = this.model;
      const loader = this.$loading.show();
      this.error = null;
      this.showSuccess = false;
      
      const setError = (error) => {
        loader.hide();
        this.error = error;
      }

      const navigateToReset = () => {
        loader.hide();
        this.$router.push({name: "SendResetCode", params: { email: username }});
      }

      try {
        api.auth.login({ username, password, authFlow: this.authFlow, handleError: setError, handleResetRequired: navigateToReset });
      } catch (error) {
        loader.hide();
          this.error = error.message
      }
    }
  }
};
</script>
